import VueRouter from 'vue-router'
import store from '../store'
const Home = () => import('../components/Home.vue')
const Login = () => import('../components/Auth/Login.vue')
const Footer = () => import('../components/Footer.vue')

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: { auth: false }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { auth: false }
    },
    {
      path: '/app/:status',
      name: 'Footer',
      component: Footer,
      meta: { auth: true }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!store.getters.isLogged && to.meta.auth) {
    return next('/login')
  }

  if (store.getters.isLogged && !to.meta.auth) {
    return next('/app/active')
  }

  next()
})

export default router
